import '../scss/app.scss';

const navTriggers = '.home .jump .nav-link';
const menuOpenClass = 'nav-open';
const menuTriggerId = 'menu-trigger';

const setMenuLinks = () => {
    const navLinkTriggers = document.querySelectorAll(navTriggers);

    for (var i = 0; i < navLinkTriggers.length; i++) {
        const menuItemAnchor = navLinkTriggers[i];  
        const triggerSelector = '.' + menuOpenClass + ' #' + menuTriggerId;
		
		menuItemAnchor.addEventListener('click', function(e){
			const mobileMenuTrigger = document.querySelector(triggerSelector);
			e.preventDefault();
			const targetLocation = this.getAttribute('href').replace('/','');;
			let target = document.querySelector(targetLocation);
			if (mobileMenuTrigger) mobileMenuTrigger.click();
			target.scrollIntoView(); 
        });
    } 
}

setMenuLinks();